import { EmailServerServiceType } from '@/services/api/emailServerApiArea/interface';
import { EmailServerService } from '@/services/api/emailServerApiArea/CustomerSettingsService';

/** Метод emailServerApiArea возвращает экземпляр EmailServerService. По необходимости можно реализовать снгл тон. **/
export const emailServerApiArea: { (): EmailServerServiceType } = () => new EmailServerService();
